import Page from "./Page";
import GorillianCanvas from "../util/GorillianCanvas";
import portrait from "../../images/IanFilmPortraitGorillian.jpg";

export default function About() {
  const skills = [
    "React",
    "JavaScript",
    "TypeScript",
    "CSS",
    "HTML",
    "Node.js",
    "Python",
    "Flask",
    "SQL",
    "PostgreSQL",
    "ThreeJS",
    "TailwindCSS",
    "Material UI",
    "CI/CD Pipelines",
    "API Development",
    "Agile Development",
    "Kanban",
    "DevOps",
    "GCP",
    "A/B Testing",
  ];
  return (
    <Page>
      <div className="banner-wrapper">
        <div className="about">
          <GorillianCanvas
            src={portrait}
            fit="cover"
            hoverTint={false}
            progress={1}
            intensity={0.85}
            logoScale={1}
            className="portrait"
            alt="Ian Miller"
          />
        </div>
        <div className="about-copy">
          <div className="about-text">
            My name is Ian Miller, I have been a software developer since 2022. I
            am from Provo Utah and enjoy soccer, reading, history, geography,
            spending time with my family and coding. <br />
            <br /> I have always been interested in understanding how computers
            work and loved to find cool websites and play video games. This
            sparked an interest for me from an early age to go into this space.
            This interest was resparked as I grew older as I began to realize that
            my mind works in numbers but I loved to express myself with art. I
            found that while my hands weren't able to get my ideas on paper very
            well, that coding allowed me to express myself using a logical medium
            and I immediately wanted to learn more.
            <br />
            <br /> I began a software development apprenticeship in January of
            2022. Through this program I learned the foundations of software
            development, and how those foundations are found in every language of
            code, I was able to make those connections with Python, Javascript and
            React as I joined their Dev team working as a full stack web
            developer. I spent a little over 2 years doing this, during which I
            had the chance to teach other apprentices Frontend Development skills
            and languages. Teaching helped me deepen the understanding I had to
            another level and realize how much I enjoyed writing code and brought
            me to my future jobs and where I am today.
          </div>
        </div>
      </div>
      <div className="section-wrapper">
        <div className="content-block content-wide">
          <h3 className="titleFont">Skills</h3>
          <ul className="skills-list">
            {skills.map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>
          <p className="skills-text">{skills.join(", ")}</p>
        </div>
        <div className="content-block content-wide">
          <h3 className="titleFont">Work</h3>
          <div className="role-grid">
            <div className="role-card">
              <h4 className="titleFont">
                Mid/Senior Frontend Engineer - SHED — Recent
              </h4>
              <p>
                Scaled Applications in the healthcare space, 3x revenue and
                conversion rates, 10x product offerings. Was able to mentor
                newer engineers and work closely with veteran engineers to build
                a strong team culture and continue developing my skills.
              </p>
            </div>
            <div className="role-card">
              <h4 className="titleFont">Full‑stack Engineer — DevPipeline</h4>
              <p>
                Worked on a team to build many full stack applications for
                clients as well as internal projects. Had the opportunity to
                teach react to over 20 junior devs entering the space.
              </p>
            </div>
            <div className="role-card">
              <h4 className="titleFont">Earlier Experience</h4>
              <p>
                Led projects that strengthened fundamentals: clean architecture,
                testing discipline, and pragmatic tooling — foundations that
                shape how I build today.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}
